import { createSlice } from "@reduxjs/toolkit";

import { ActivationEmailKeys, SliceKeys } from "@sso/constant";
import { RootState } from "@sso/store";
import { AuthState } from "@sso/types";

import { authReducers } from "./reducers";

const initialState: AuthState = { currentUser: null, activationEmailStatus: ActivationEmailKeys.DISABLE };

export const AuthSlice = createSlice({
  name: SliceKeys.AUTH,
  initialState,
  reducers: { ...authReducers },
});

export const { logInUser, logOutUser, setActivationEmailStatus, updateProfilePicture, getUserFromSession } =
  AuthSlice.actions;
export const selectCurrentUser = (state: RootState) => state.auth.currentUser;
export const selectActivationEmailStatus = (state: RootState) => state.auth.activationEmailStatus;

export default AuthSlice.reducer;
